import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons"; // Иконки глазика
import axios from "axios";
const OnboardingStepper = ({ divisions, email }) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    fullname: "",
    email: email || "",
    username: "",
    password: "",
    confirmPassword: "",
    division: "",
  });

  const [showPassword, setShowPassword] = useState(false); // Управление показом пароля
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Для подтверждения пароля

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
    } else if (field === "confirmPassword") {
      setShowConfirmPassword(!showConfirmPassword);
    }
  };

  const validateStep = () => {
    switch (step) {
      case 1:
        return formData.fullname && formData.email;
      case 2:
        debugger;
        return (
          formData.username && formData.password === formData.confirmPassword
        );
      case 3:
        return formData.division;
      default:
        return false;
    }
  };

  const handleNext = () => {
    if (validateStep()) {
      setStep(step + 1);
    } else {
      toast.error("Заполните все поля корректно!");
    }
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post("/session/sign_up", {
        user: {
          fullname: formData.fullname,
          email: formData.email,
          username: formData.username,
          password: formData.password,
          division: formData.division,
          confirm_password: formData.confirmPassword,
        },
      });
  
      if (response.status === 201 || response.status === 200) {
        toast.success("Пользователь успешно зарегистрирован!");
        setTimeout(() => {
          window.location.href = "/reports";
        }, 1000); // Задержка для показа уведомления
      } else {
        toast.error("Ошибка при регистрации. Попробуйте снова.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.errors) {
        // Отображаем ошибки с сервера
        error.response.data.errors.forEach((err) => toast.error(err));
      } else {
        // Если ошибки с сервера нет, показываем общее сообщение
        toast.error("Ошибка при регистрации. Попробуйте снова.");
      }
      console.error("Ошибка при отправке данных:", error);
    }
  };
  
  const progressBarWidth = `${(step / 3) * 100}%`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-lg">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Регистрация
        </h1>

        {/* Прогресс-бар */}
        <div className="relative w-full bg-gray-200 rounded-full h-2 mb-6">
          <div
            className="absolute top-0 left-0 bg-blue-600 h-2 rounded-full"
            style={{ width: progressBarWidth }}
          />
        </div>

        {/* Шаги формы */}
        {step === 1 && (
          <>
            <label className="block mb-3">
              <span className="text-gray-700">ФИО</span>
              <input
                type="text"
                name="fullname"
                placeholder="Введите ваше полное имя"
                className="mt-1 block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={formData.fullname}
                onChange={handleChange}
              />
            </label>

            <label className="block mb-3">
              <span className="text-gray-700">E-mail</span>
              <input
                type="email"
                name="email"
                placeholder="Ваш e-mail"
                className="mt-1 block w-full p-3 border border-gray-300 rounded-md bg-gray-100"
                value={formData.email}
                readOnly
              />
            </label>
          </>
        )}

        {step === 2 && (
          <>
            <label className="block mb-3">
              <span className="text-gray-700">Логин</span>
              <input
                type="text"
                name="username"
                placeholder="Введите логин"
                className="mt-1 block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                value={formData.username}
                onChange={handleChange}
              />
            </label>
            <label className="block mb-3 relative">
              <span className="text-gray-700">Пароль</span>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Введите пароль"
                  className="mt-1 block w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={formData.password}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-2 flex items-center text-gray-500"
                  onClick={() => togglePasswordVisibility("password")}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </label>
            <label className="block mb-3 relative">
              <span className="text-gray-700">Подтвердите пароль</span>
              <div className="relative">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Повторите пароль"
                  className="mt-1 block w-full p-3 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-2 flex items-center text-gray-500"
                  onClick={() => togglePasswordVisibility("confirmPassword")}
                >
                  <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                </button>
              </div>
            </label>
          </>
        )}

        {step === 3 && (
          <label className="block mb-3">
            <span className="text-gray-700">Подразделение</span>
            <select
              name="division"
              className="mt-1 block w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              value={formData.division}
              onChange={handleChange}
            >
              <option value="">Выберите подразделение</option>
              {divisions.map((div) => (
                <option key={div.id} value={div.id}>
                  {div.name}
                </option>
              ))}
            </select>
          </label>
        )}

        {/* Кнопки управления */}
        <div className="flex justify-between mt-6">
          {step > 1 && (
            <button
              className="px-4 py-2 bg-gray-300 text-gray-700 rounded-md hover:bg-gray-400"
              onClick={() => setStep(step - 1)}
            >
              Назад
            </button>
          )}
          {step < 3 ? (
            <button
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              onClick={handleNext}
            >
              Далее
            </button>
          ) : (
            <button
              className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
              onClick={handleSubmit}
            >
              Завершить
            </button>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default OnboardingStepper;
